import { z } from 'zod';
import { eventSchema } from './envelope';

export const SCHEDULING_OCCURRENCE_DUE_V1 = 'scheduling.occurrence.due.v1' as const;
export const SCHEDULING_OCCURRENCE_PUBLISHED_V1 = 'scheduling.occurrence.published.v1' as const;
export const SCHEDULING_OCCURRENCE_FAILED_V1 = 'scheduling.occurrence.failed.v1' as const;

/**
 * Een gepland moment is aangebroken (Stap 14).
 *
 * `kind` zegt wie het oppakt: een bericht publiceert `scheduling` zelf via `CommunicationApi`, een
 * checklist zet `tasks` klaar (de naad uit ADR-0064). Eén event per voorkomen; het voorkomen is
 * vooraf geclaimd, dus twee workers leveren nooit twee events.
 */
export const occurrenceDueV1Schema = eventSchema({
  occurrenceId: z.guid(),
  scheduleId: z.guid(),
  kind: z.enum(['post', 'checklist']),
  targetId: z.guid(),
  dueAt: z.string().datetime(),
});
export type OccurrenceDueV1 = z.infer<typeof occurrenceDueV1Schema>;

export const occurrencePublishedV1Schema = eventSchema({
  occurrenceId: z.guid(),
  scheduleId: z.guid(),
  kind: z.enum(['post', 'checklist']),
  targetId: z.guid(),
  resultId: z.guid(),
});
export type OccurrencePublishedV1 = z.infer<typeof occurrencePublishedV1Schema>;

export const occurrenceFailedV1Schema = eventSchema({
  occurrenceId: z.guid(),
  scheduleId: z.guid(),
  kind: z.enum(['post', 'checklist']),
  targetId: z.guid(),
  reason: z.string(),
});
export type OccurrenceFailedV1 = z.infer<typeof occurrenceFailedV1Schema>;

export const schedulingEventCatalog = {
  [SCHEDULING_OCCURRENCE_DUE_V1]: occurrenceDueV1Schema,
  [SCHEDULING_OCCURRENCE_PUBLISHED_V1]: occurrencePublishedV1Schema,
  [SCHEDULING_OCCURRENCE_FAILED_V1]: occurrenceFailedV1Schema,
} as const;

export const SCHEDULING_SCHEDULE_CHANGED_V1 = 'scheduling.schedule.changed.v1' as const;

/** Een planning is aangemaakt, gewijzigd, gepauzeerd, hervat of geannuleerd (Stap 18). */
export const scheduleChangedV1Schema = eventSchema({
  scheduleId: z.guid(),
  kind: z.enum(['post', 'checklist']),
  targetId: z.guid(),
  action: z.enum(['created', 'updated', 'paused', 'resumed', 'cancelled']),
});
export type ScheduleChangedV1 = z.infer<typeof scheduleChangedV1Schema>;
